import {observer} from 'mobx-react';
import {ActionLink, Avatar, ProgressIndicator} from 'shared/components';
import {dateSpan} from 'shared/tools';
import GoalStatusTag from './GoalStatusTag';

const ProgressBar = observer(({model, level}) => {
  const paddingLeft = 32 * level;
  return (
    <div className='flex full-width' style={{paddingLeft}}>
      <div className='col-4 jumbo right-align mr1 whitespace-pre'>{model.formattedCompleteness}</div>
      <div className='col-8'>
        <ProgressIndicator items={model.progressBarItems}/>
      </div>
    </div>
  );
});

export const GoalNameCell = observer(({model, level, uiState}) => {
  const goal = model;
  return (
    <div>
      {!!goal.parentGoalTitle && level === 0 && <div className='flex align-items-middle mb1'>
        <i className='jumbo mr1 material-icons h4'>arrow_forward</i>
        <span className='jumbo'>{goal.parentGoalTitle}</span>
      </div>}
      {goal.canViewFullDetails ? <ActionLink onClick={() => uiState.goToGoal(goal)}>{goal.title}</ActionLink> : goal.title}
    </div>
  );
});

export const AssigneeCell = observer(({model}) => {
  return <div className='full-width right-align'>
    <Avatar employee={model.employee} size='sm'/>
  </div>;
});

export const PeriodCell = observer(({model}) => {
  return <span>{dateSpan(model.startDate, model.endDate, true)}</span>;
});

export const StatusCell = observer(({model}) => {
  return <GoalStatusTag goal={model}/>;
});

export const ProgressCell = observer(({model, level}) => {
  return <ProgressBar model={model} level={level}/>;
});

export const MetricNameCell = observer(({model}) => {
  return <span className='truncate'>{model.name}</span>;
});
